import {
  Backdrop,
  Box,
  Button,
  Chip,
  CircularProgress,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CustomSnackbar from "../../components/ui-component/snackbar/CustomSnackbar";
import { useNavigate } from "react-router-dom";
import { fDate } from "../../../utils/formatTime";
import CustomPopup from "../../../components/CustomPopup";
import EmployeeLeaveRequestForm from "./EmployeeLeaveRequestForm";
import EmployeeViewForm from "./EmployeeViewForm";
import EmployeeLeaveFilter from "./EmployeeLeaveFilter";
import { useGetTokenOrLogout } from "../../../utils/token";
import HeadingCard from "../../newComponent/NewCardsComp/HeadingCard";
import AddButton from "../../newComponent/NewButtonComp/AddButton";
import FilterButtonComponent from "../../newComponent/NewButtonComp/FilterButtonComponent";
import StyledTableContainer from "../../newComponent/TableContainer";
import MainCard from "../../../components/Maincard";
import VeiwIcon from "../../newComponent/iconsComp/VeiwIcon";
import EditIconcomp from "../../newComponent/iconsComp/EditIconcomp";
import ConfirmationPopup from "../../../components/ConfirmationPopup";
import DenyIcon from "../../newComponent/iconsComp/DenyIcon";
import ApproveIcon from "../../newComponent/iconsComp/ApproveIcon";

import CustomNoRowsOverlay from "../../newComponent/TableCustomeComp/CustomNoRowsOverlay";
import { DataGrid } from "@mui/x-data-grid";
import CancelIcon from "../../newComponent/iconsComp/CancelIcon";
import CancelIconcomp from "../../newComponent/iconsComp/CancelIcon";
import EditTrainerLeaveRequest from "./EditTrainerLeaveRequest";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

function EmployeeLeaveRequests() {
  const navigate = useNavigate();
  const getTokenOrLogout = useGetTokenOrLogout();
  const userId = localStorage.getItem("userId");
  const userRole = localStorage.getItem("userRole");
  const [isLoading, setIsLoading] = useState(false);
  const [leaveRequests, setLeaveRequests] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [filterCriteria, setFilterCriteria] = useState(null);
  const [openLeaveRequestPopup, setAddLeaveRequestPopup] = useState(false);
  const [openViewRequestPopup, setViewRequestPopup] = useState(false);
  const [requestDetails, setRequestDetails] = useState(null);
  const [anotherEmployeeRequest, setAnotherEmployeeRequest] = useState(false);
  const [cancelOpen, setCancelOpen] = useState(false);
  const [confirmPopup, setConfirmPopup] = useState(false);
  const [denyPopup, setDenyPopup] = useState(false);
  const [open, setOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [editOpen, setEditOpen] = useState(false);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState("");
  const [snackbarSeverity, setSnackbarSeverity] = React.useState("success");

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const columns = [
    {
      field: "action",
      headerName: "Action",
      width: 150,
      sortable: false,
      disableColumnMenu: true,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <div style={{ display: "flex", gap: 5 }}>
          {" "}
          {params?.row?.leave_status === "pending" && (
            <>
              <EditIconcomp
                tooltipTitle="Edit Request"
                onClick={() => handleOpenEditRequestPopup(params?.row)}
                fontSize="0.9rem"
              />
              <CancelIconcomp
                tooltipTitle="Cancel Request"
                onClick={() =>
                  handleCancelOpenPopup(params?.row.id, "cancelled")
                }
                fontSize="0.9rem"
              />
            </>
          )}
          {userRole === "admin" && params?.row?.leave_status === "pending" && (
            <>
              <ApproveIcon
                tooltipTitle="Approve Request"
                onClick={() =>
                  handleConfirmOpenPopup(params?.row?.id, "accepted")
                }
                fontSize="0.9rem"
              />

              <DenyIcon
                tooltipTitle="Deny Request"
                onClick={() => handleDenyOpenPopup(params?.row?.id, "denied")}
                fontSize="0.9rem"
              />
            </>
          )}
          {params?.row?.leave_status !== "pending" && (
            <VeiwIcon
              tooltipTitle="View Request"
              onClick={() => handleOpenViewRequestPopup(params?.row)}
              fontSize="0.9rem"
            />
          )}
        </div>
      ),
    },

    {
      field: "employee_name",
      headerName: "Employee Name",
      width: 150,
      headerClassName: "header-cell",
      valueGetter: (params) =>
        `${params?.row?.emp_user_id?.first_name || ""} ${
          params?.row?.emp_user_id?.last_name || ""
        }`,
      renderCell: (params) => (
        <div>
          {params?.row?.emp_user_id?.first_name}{" "}
          {params?.row?.emp_user_id?.last_name}
        </div>
      ),
    },

    {
      field: "leave_status",
      headerName: "Leave Status",
      width: 150,
      headerClassName: "header-cell",
      valueGetter: (params) =>
        `${params?.row?.emp_user_id?.first_name || ""} ${
          params?.row?.emp_user_id?.last_name || ""
        }`,
      renderCell: (params) => (
        <div>
          {params?.row?.leave_status === "accepted" && (
            <Chip
              size="small"
              variant="contained"
              label="Approved"
              color="secondary"
            />
          )}
          {params?.row?.leave_status === "denied" && (
            <Chip
              size="small"
              variant="contained"
              label="Denied"
              color="primary"
            />
          )}
          {params?.row?.leave_status === "pending" && (
            <Chip
              size="small"
              variant="contained"
              label="Pending"
              color="warning"
            />
          )}
          {params?.row?.leave_status === "cancelled" && (
            <Chip
              size="small"
              variant="contained"
              label="Cancelled"
              color="error"
            />
          )}
        </div>
      ),
    },

    {
      field: "branch",
      headerName: "Branch",
      width: 150,
      headerClassName: "header-cell",
      valueGetter: (params) => `${params?.row?.emp_user_id?.branch_name || ""}`,
      renderCell: (params) => (
        <div>{params?.row?.emp_user_id?.branch_name} </div>
      ),
    },
    {
      field: "leave_day_type",
      headerName: "Application Type",
      width: 150,
      headerClassName: "header-cell",

      renderCell: (params) => (
        <div>
          {params?.row?.leave_day_type === "full" && (
            <Chip
              size="small"
              variant="contained"
              label="Full Day"
              color="warning"
            />
          )}
          {params?.row?.leave_day_type === "first_half" && (
            <Chip
              size="small"
              variant="contained"
              label="First Half"
              color="warning"
            />
          )}
          {params?.row?.leave_day_type === "second_half" && (
            <Chip
              size="small"
              variant="contained"
              label="Second Half"
              color="warning"
            />
          )}
          {params?.row?.leave_day_type === "short_morning" && (
            <Chip
              size="small"
              variant="contained"
              label="Short Leave - Morning"
              color="warning"
            />
          )}
          {params?.row?.leave_day_type === "short_evening" && (
            <Chip
              size="small"
              variant="contained"
              label="Short Leave - Evening"
              color="warning"
            />
          )}
        </div>
      ),
    },
    {
      field: "leave_type_id",
      headerName: "Type Of Leave",
      width: 150,
      headerClassName: "header-cell",
      valueGetter: (params) =>
        `${params?.row?.leave_type_id?.leave_type || ""}`,
      renderCell: (params) => (
        <div>{params?.row?.leave_type_id?.leave_type} </div>
      ),
    },
    {
      field: "from_date",
      headerName: "From Date",
      width: 150,
      headerClassName: "header-cell",
      renderCell: (params) => <div> {fDate(params?.row?.from_date)} </div>,
    },
    {
      field: "to_date",
      headerName: "To Date",
      width: 150,
      headerClassName: "header-cell",
      renderCell: (params) => <div> {fDate(params?.row?.to_date)} </div>,
    },

    {
      field: "createdAt",
      headerName: "Requested Date",
      width: 150,
      headerClassName: "header-cell",
      renderCell: (params) => <div> {fDate(params?.row?.createdAt)} </div>,
    },

    // {
    //   field: "approve_by",
    //   headerName: "Approve/Denied/Cancel By",
    //   width: 150,
    //   headerClassName: "header-cell",
    //   valueGetter: (params) =>
    //     `${params?.row?.approved_by?.first_name || ""} ${
    //       params?.row?.approved_by?.last_name || ""
    //     }`,
    //   renderCell: (params) => (
    //     <div>
    //       {params?.row?.approved_by?.first_name}{" "}
    //       {params?.row?.approved_by?.last_name}
    //     </div>
    //   ),
    // },

    // {
    //   field: "approve_date",
    //   headerName: "Approve/Denied/Cancel Date",
    //   width: 150,
    //   headerClassName: "header-cell",
    //   renderCell: (params) => <div> {fDate(params?.row?.approved_date)} </div>,
    // },
  ];

  const handleOpenLeaveRequestPopup = (bool) => {
    setAddLeaveRequestPopup(true);
    setAnotherEmployeeRequest(bool);
  };

  const handleCloseLeaveRequestPopup = () => {
    setAddLeaveRequestPopup(false);
    setAnotherEmployeeRequest(false);
  };

  const handleOpenViewRequestPopup = (row) => {
    setViewRequestPopup(true);
    setRequestDetails(row);
  };

  const handleCloseViewRequestPopup = () => {
    setViewRequestPopup(false);
    setRequestDetails(null);
  };

  // Edit Popup
  const handleOpenEditRequestPopup = (row) => {
    setEditOpen(true);
    setRequestDetails(row);
  };

  const handleCloseEditRequestPopup = () => {
    setEditOpen(false);
    setRequestDetails(null);
  };

  useEffect(() => {
    setIsLoading(true);
    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${API_ENDPOINT}route2.0/getempleaverequest/${userId}`,
          { headers }
        );
        if (response.ok) {
          const data = await response.json();

          const sortedData = data.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );

          let filteredData = [...sortedData];
          if (filterCriteria) {
            filteredData = filteredData.filter((leave) => {
              let passesFilter = true;

              if (filterCriteria.newCreatedby.length > 0) {
                passesFilter =
                  passesFilter &&
                  filterCriteria.newCreatedby.includes(leave?.emp_user_id?.id);
              }

              if (filterCriteria.newStatus.length > 0) {
                passesFilter =
                  passesFilter &&
                  filterCriteria.newStatus.includes(leave?.leave_status);
              }

              if (filterCriteria.newBranch.length > 0) {
                passesFilter =
                  passesFilter &&
                  filterCriteria.newBranch.includes(
                    leave?.created_by?.branch_name
                  );
              }

              if (filterCriteria.newApplicationType.length > 0) {
                passesFilter =
                  passesFilter &&
                  filterCriteria.newApplicationType.includes(
                    leave?.leave_day_type
                  );
              }

              if (filterCriteria.newLeaveType.length > 0) {
                passesFilter =
                  passesFilter &&
                  filterCriteria.newLeaveType.includes(
                    leave?.leave_type_id?.id
                  );
              }

              // filter for requested date
              if (filterCriteria.requestedFrom && filterCriteria.requestedTo) {
                const startDate = filterCriteria.requestedFrom;
                const endDate = filterCriteria.requestedTo;
                const createddate = new Date(leave?.createdAt);
                const formattedDate = createddate.toISOString().slice(0, 10);
                console.log("formated date is", formattedDate);
                passesFilter =
                  passesFilter &&
                  formattedDate >= startDate &&
                  formattedDate <= endDate;
              }

              // filter for start and end date
              if (filterCriteria.leaveFrom && filterCriteria.leaveTo) {
                const startDate = filterCriteria.leaveFrom;
                const endDate = filterCriteria.leaveTo;
                const leaveStartDate = leave?.from_date;
                const leaveEnddate = leave?.to_date;
                passesFilter =
                  passesFilter &&
                  leaveStartDate >= startDate &&
                  leaveStartDate <= startDate &&
                  leaveEnddate >= endDate &&
                  leaveEnddate <= endDate;
              }

              //Filter for Leave from date Only
              if (
                filterCriteria.leaveStartfrom &&
                filterCriteria.leaveStartTo
              ) {
                const startDate = filterCriteria.leaveStartfrom;
                const endDate = filterCriteria.leaveStartTo;
                const createddate = leave?.from_date;

                passesFilter =
                  passesFilter &&
                  createddate >= startDate &&
                  createddate <= endDate;
              }

              // filter for Leave to Only
              if (filterCriteria.leaveEndfrom && filterCriteria.leaveEndTo) {
                const startDate = filterCriteria.leaveEndfrom;
                const endDate = filterCriteria.leaveEndTo;
                const createddate = leave?.to_date;

                passesFilter =
                  passesFilter &&
                  createddate >= startDate &&
                  createddate <= endDate;
              }

              return passesFilter;
            });
          }

          setLeaveRequests(filteredData);
          setOriginalData(sortedData);
          console.log(sortedData);
          setIsLoading(false);
        } else if (response.status === 404) {
          navigate("/page404");
        } else if (response.status === 401) {
          navigate("/page401");
        } else if (response.status === 403) {
          navigate("/page403");
        } else if (response.status === 440) {
          navigate("/page440");
        } else {
          navigate("/page500");
        }
      } catch {
        navigate("/page500");
      }
    };

    fetchData();
  }, [userId, filterCriteria]);

  const handleApplyFilter = (criteria) => {
    setFilterCriteria(criteria);
  };
  const handleResetFilter = () => {
    setFilterCriteria(null);
    setLeaveRequests(originalData);
  };

  const handleToggle = () => {
    setOpen(!open);
  };

  const handleCancelOpenPopup = (rowId, status) => {
    setCancelOpen(true);
    setSelectedId(rowId);
    setSelectedStatus(status);
  };

  const handleCancelClosePopup = () => {
    setCancelOpen(false);
  };

  const handleConfirmOpenPopup = (rowId, status) => {
    setConfirmPopup(true);
    setSelectedId(rowId);
    setSelectedStatus(status);
  };

  const handleConfirmClosePopup = () => {
    setConfirmPopup(false);
  };

  // Deny popup

  const handleDenyOpenPopup = (rowId, status) => {
    setDenyPopup(true);
    setSelectedId(rowId);
    setSelectedStatus(status);
  };

  const handleDenyClosePopup = () => {
    setDenyPopup(false);
  };

  //
  const handleUpdateStatus = () => {
    // Send a request to the server to update the status
    fetch(`${API_ENDPOINT}empleave/${selectedId}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        leave_status: selectedStatus,
        user_id: parseInt(userId),
      }),
    })
      .then((response) => {
        if (response.ok) {
          showSnackbar("Leave status updated successfully", "success");

          setTimeout(() => {
            window.location.reload();
          }, 1500);
        } else {
          showSnackbar("Failed to update leave status", "error");
          throw new Error("Failed to update leave status");
        }
        // Handle successful response if needed
      })
      .catch((error) => {
        console.error("Error updating leave status:", error);
        showSnackbar("Error updating leave status", "error");
        // Revert the status locally if the server update fails
      });
  };

  return (
    <>
      <Backdrop open={isLoading} style={{ zIndex: 9999 }}>
        <Typography variant="h4" color="error" fontWeight={800} marginRight={2}>
          Fetching
        </Typography>
        <CircularProgress color="primary" />
      </Backdrop>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={5} lg={3}>
          <HeadingCard label="Trainer Leave Request" />
        </Grid>
        <Grid
          item
          xs={12}
          lg={9}
          sm={12}
          md={12}
          container
          justifyContent="end"
          gap={1}
        >
          <AddButton
            label="Add Leave Request"
            onClick={() => {
              handleOpenLeaveRequestPopup(false);
            }}
          />

          {/* {userRole === "admin" && (
            <AddButton
              label="Add Another Employee Request"
              onClick={() => {
                handleOpenLeaveRequestPopup(true);
              }}
            />
          )} */}
          <FilterButtonComponent showendIcon={true} onClick={handleToggle} />
        </Grid>

        <Grid item xs={12} lg={12} sm={12} md={12}>
          <EmployeeLeaveFilter
            onApplyFilter={handleApplyFilter}
            onResetFilter={handleResetFilter}
            open={open}
            handleToggle={handleToggle}
          />
        </Grid>

        <Grid item xs={12}>
          <MainCard>
            {/* <StyledTableContainer component={Paper}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell>Action</TableCell>
                    <TableCell>Employee Details</TableCell>

                    <TableCell>Status</TableCell>

                    <TableCell>Branch</TableCell>
                    <TableCell>Application Type</TableCell>
                    <TableCell>Type of leave</TableCell>
                    <TableCell>Leave From Date</TableCell>
                    <TableCell>Leave To Date</TableCell>
                    <TableCell>Request Date</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {leaveRequests.length === 0 ? (
                    <Grid
                      item
                      xs={12}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Typography variant="h5">No data available</Typography>
                    </Grid>
                  ) : (
                    leaveRequests
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row, index) => (
                        <TableRow
                          key={index}
                          style={{
                            backgroundColor:
                              index % 2 === 0 ? "#f0f0f0" : "inherit",
                          }}
                        >
                          <TableCell>
                            <EditIconcomp
                              tooltipTitle="View Request"
                              onClick={() => handleOpenViewRequestPopup(row)}
                              fontSize="0.9rem"
                            />
                            <DenyIcon
                              tooltipTitle="Cancel Request"
                              onClick={() =>
                                handleCancelOpenPopup(row.id, "cancelled")
                              }
                              fontSize="0.9rem"
                            />
                          </TableCell>
                          <TableCell>
                            {`${
                              row?.emp_user_id?.first_name
                                ? row?.emp_user_id?.first_name
                                : ""
                            } ${
                              row?.emp_user_id?.last_name
                                ? row?.emp_user_id?.last_name
                                : ""
                            }`}{" "}
                            <br />
                          </TableCell>
                          <TableCell>
                            {row?.leave_status === "accepted" && (
                              <Chip
                                size="small"
                                variant="contained"
                                label="Approved"
                                color="secondary"
                              />
                            )}
                            {row?.leave_status === "denied" && (
                              <Chip
                                size="small"
                                variant="contained"
                                label="Denied"
                                color="error"
                              />
                            )}
                            {row?.leave_status === "pending" && (
                              <Chip
                                size="small"
                                variant="contained"
                                label="Pending"
                                color="warning"
                              />
                            )}
                            {row?.leave_status === "cancelled" && (
                              <Chip
                                size="small"
                                variant="contained"
                                label="Cancelled"
                                color="primary"
                              />
                            )}
                          </TableCell>
                          <TableCell>{row?.emp_user_id?.branch_name}</TableCell>
                          <TableCell>
                            {row?.leave_day_type === "full" && (
                              <Chip
                                size="small"
                                variant="contained"
                                label="Full Day"
                                color="warning"
                              />
                            )}
                            {row?.leave_day_type === "first_half" && (
                              <Chip
                                size="small"
                                variant="contained"
                                label="First Half"
                                color="warning"
                              />
                            )}
                            {row?.leave_day_type === "second_half" && (
                              <Chip
                                size="small"
                                variant="contained"
                                label="Second Half"
                                color="warning"
                              />
                            )}
                            {row?.leave_day_type === "short_morning" && (
                              <Chip
                                size="small"
                                variant="contained"
                                label="Short Leave - Morning"
                                color="warning"
                              />
                            )}
                            {row?.leave_day_type === "short_evening" && (
                              <Chip
                                size="small"
                                variant="contained"
                                label="Short Leave - Evening"
                                color="warning"
                              />
                            )}
                          </TableCell>
                          <TableCell>
                            {row?.leave_type_id?.leave_type}
                          </TableCell>
                          <TableCell>{fDate(row?.from_date)}</TableCell>
                          <TableCell>{fDate(row?.to_date)}</TableCell>
                          <TableCell>{fDate(row?.createdAt)}</TableCell>
                        </TableRow>
                      ))
                  )}
                </TableBody>
              </Table>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={leaveRequests.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </StyledTableContainer> */}

            <Grid item xs={12}>
              <DataGrid
                rows={leaveRequests}
                columns={columns}
                slots={{
                  noRowsOverlay: CustomNoRowsOverlay,
                }}
                autoHeight
                initialState={{
                  pagination: {
                    paginationModel: {
                      pageSize: 25,
                    },
                  },
                }}
                pageSizeOptions={[25, 50, 100]}
              />
            </Grid>
          </MainCard>
        </Grid>
      </Grid>
      <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />

      <CustomPopup
        open={openLeaveRequestPopup}
        onClose={handleCloseLeaveRequestPopup}
        component={
          <EmployeeLeaveRequestForm
            onClose={handleCloseLeaveRequestPopup}
            anotherEmployeeRequest={anotherEmployeeRequest}
          />
        }
        title="Add Leave Request"
        maxWidth="sm"
        showDivider={true}
      />

      <CustomPopup
        open={editOpen}
        onClose={handleCloseEditRequestPopup}
        component={
          <EditTrainerLeaveRequest
            onClose={handleCloseEditRequestPopup}
            data={requestDetails}
          />
        }
        title="Edit Leave Request"
        maxWidth="sm"
        showDivider={true}
      />

      <ConfirmationPopup
        open={cancelOpen}
        onClose={handleCancelClosePopup}
        title="Cancel Request Confirmation"
        textBody="Are you sure you want to cancel this leave request?"
        maxWidth="xs"
        showDivider={true}
        handleUpdateStatus={handleUpdateStatus}
      />
      <ConfirmationPopup
        open={confirmPopup}
        onClose={handleConfirmClosePopup}
        title="Accept Request Confirmation"
        textBody="Are you sure you want to  accept this leave request?"
        maxWidth="xs"
        showDivider={true}
        handleUpdateStatus={handleUpdateStatus}
      />

      <ConfirmationPopup
        open={denyPopup}
        onClose={handleDenyClosePopup}
        title="Deny Request Confirmation"
        textBody="Are you sure you want to deny this leave request?"
        maxWidth="xs"
        showDivider={true}
        handleUpdateStatus={handleUpdateStatus}
      />

      <CustomPopup
        open={openViewRequestPopup}
        onClose={handleCloseViewRequestPopup}
        component={
          <EmployeeViewForm
            onClose={handleCloseViewRequestPopup}
            data={requestDetails}
          />
        }
        title="View Leave Request"
        maxWidth="sm"
        showDivider={true}
      />
    </>
  );
}

export default EmployeeLeaveRequests;
